import React from "react";
import CommentsTab from '../../CommentsTab'
export const Comments = (props) => {
  return <CommentsTab {...props}/>
};
